import { HypothesisKey } from 'features/creatives';

const NO_HYPOTHESIS: string = HypothesisKey.NoHypothesis;

const compareHypothesisNames = (a: string, b: string): number => {
  if (a === b) return 0;
  if (a === NO_HYPOTHESIS) return -1;
  if (b === NO_HYPOTHESIS) return 1;
  return a.localeCompare(b);
};

export default compareHypothesisNames;
